import * as Sentry from '@sentry/react';
import _ from 'underscore';
import BaseStore from 'vendor/cnpm/fluxible.v0-4/addons/BaseStore';

const SERIALIZED_PROPS: Array<keyof CourseReferencesStore$DehydratedState> = [
  'loaded',
  'referencesList',
  'currentReference',
  'cachedReferences',
];

type CourseReferencesStore$DehydratedState = {
  loaded: boolean;
  referencesList: Array<any>;
  currentReference: any;
  cachedReferences: any;
};

class CourseReferencesStore extends BaseStore {
  static storeName = 'CourseReferencesStore';

  static handlers = {
    LOAD_REFERENCES_LIST: 'onLoadReferencesList',
    LOAD_REFERENCE: 'onLoadReference',
    REFERENCE_LIST_LOAD_FAILURE: 'onReferenceListLoadFailure',
  };

  onReferenceListLoadFailure(error: Error) {
    Sentry.captureException(error);
    this.loaded = true;
    this.error = error;
    this.emitChange();
  }

  onLoadReferencesList(response: $TSFixMe) {
    // response is of the following format
    // [Object, Object, ...]
    // Object: {id, shortId, content, name, slug}
    this.referencesList = response;
    this.loaded = true;
    this.error = undefined;
    this.emitChange();
  }

  onLoadReference(response: $TSFixMe) {
    // this is an object of the following format
    // {name, shortId, id, slug, content: {dtdType, definition, id}}
    if (response) {
      this.error = undefined;
      this.currentReference = response;
      this.cachedReferences[response.shortId] = response;
      this.emitChange();
    }
  }

  declare emitChange: () => void;

  declare currentReference: any;

  declare error?: Error;

  cachedReferences: any = {};

  loaded = false;

  declare referencesList: Array<any>;

  dehydrate(): CourseReferencesStore$DehydratedState {
    return _(this).pick(...SERIALIZED_PROPS);
  }

  rehydrate(state: CourseReferencesStore$DehydratedState) {
    Object.assign(this, _(state).pick(...SERIALIZED_PROPS));
  }

  getReferencesList() {
    return this.referencesList;
  }

  getCurrentReference() {
    return this.currentReference;
  }

  getCurrentReferenceShortId() {
    return this.currentReference ? this.currentReference.shortId : null;
  }

  getCachedReference(shortId: string) {
    return this.cachedReferences && this.cachedReferences[shortId];
  }

  hasLoaded() {
    return this.loaded;
  }
}

export default CourseReferencesStore;
